
import router from './router'
router.beforeEach((to, from, next) => {
    // document.title = `南软科技-${to.meta.title}`
    next()
})

router.afterEach((to, from) => {

})


// WEBPACK FOOTER //
// ./src/permission.js